"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 10px;\n  border-radius: 10px;\n  width: 10px;\n\n  &.primary {\n    background: ", ";\n  }\n\n  &.success {\n    background: ", ";\n  }\n\n  &.info {\n    background: ", ";\n  }\n\n  &.warning {\n    background: ", ";\n  }\n\n  &.error {\n    background: ", ";\n  }\n"], ["\n  height: 10px;\n  border-radius: 10px;\n  width: 10px;\n\n  &.primary {\n    background: ", ";\n  }\n\n  &.success {\n    background: ", ";\n  }\n\n  &.info {\n    background: ", ";\n  }\n\n  &.warning {\n    background: ", ";\n  }\n\n  &.error {\n    background: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.ongoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.attemptOngoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map